export default "__VITE_ASSET__D$UnI5By__"